import LogApi from '@/api/common/log';
import {sendLegacyInflowPathLog} from '../my/log';

export const sendClickLog = (codeType = '', sendData) => {
  const params = {
    codeType,
    sendData,
  };

  LogApi.sendClickLog(params);
};

/**
 * 상단 비주얼 영역 클릭했을 때 라이브일 경우 보내는 유입로그
 * @param {Object} params
 * @param {number} params.streamerId - 스트리머 id
 * @param {number} params.broadcastId - 방송 id
 */
export const sendTopListLiveInflowLog = ({streamerId, broadcastId}) => {
  sendLegacyInflowPathLog({
    isLogSendData: {
      contentsType: 'live',
      entry_way: 'list_auto_to_player',
      path2: '', // 이 위치에서는 path1만 보내줘야하는데 path2의 기본값이 'list'라서 지워줌
    },
    streamerId,
    broadcastId,
    categoryTags: [],
    hashTags: [],
  });
};
